// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1JoiW","label":"Radio_label__1VKql","checkMark":"Radio_checkMark__1JJuR","disabled":"Radio_disabled__HaOYu"};